import React from "react";
import Service from "./Service";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

const SERVICES = [
  {
    title: "User experience & interface Design",
    description:
      "Creating intuitive and seamless interactions for users, enhancing satisfaction and usability.",
    image: require("../assets/desktop.png"),
  },
  {
    title: "Web Development & Responsive Coding",
    description:
      "Building dynamic and adaptable web applications , ensuring optimal user experience across devices and screen sizes.",
    image: require("../assets/web.png"),
  },
  {
    title: "Mobile Application Development",
    description:
      "Crafting immersive and engaging experiences through the creation of innovative mobile applications .",
    image: require("../assets/mobile.png"),
  },
];
function Services({ section }) {
  const [subtitle, subtitleInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const [title, titleInView] = useInView({
    triggerOnce: true, // Animation triggered only once
    threshold: 0.5, // Adjust the threshold as needed
  });
  const animationVariants = {
    hidden: {
      opacity: 0,
      y: 50,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 1,
        ease: "easeInOut",
      },
    },
  };
  return (
    <div className="services-section" ref={section}>
      <motion.div
        className="sub-title"
        ref={subtitle}
        initial="hidden"
        animate={subtitleInView ? "visible" : "hidden"}
        variants={animationVariants}
      >
        Services
      </motion.div>
      <motion.div
        className="title"
        ref={title}
        initial="hidden"
        animate={titleInView ? "visible" : "hidden"}
        variants={animationVariants}
      >
        Create Solutions
      </motion.div>
      <div className="services">
        {SERVICES.map((item, index) => (
          <Service key={index} item={item} index={index} />
        ))}
      </div>
    </div>
  );
}

export default Services;
